import { render, staticRenderFns } from "./UmbOnboardingInfo.vue?vue&type=template&id=6da01f4c&scoped=true"
import script from "./UmbOnboardingInfo.vue?vue&type=script&lang=ts"
export * from "./UmbOnboardingInfo.vue?vue&type=script&lang=ts"
import style0 from "./UmbOnboardingInfo.vue?vue&type=style&index=0&id=6da01f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da01f4c",
  null
  
)

export default component.exports